export default class Header {
  constructor(el) {
    this.el = el;

    const alert = document.querySelector('.g-alert');
    const main = document.querySelector('main');

    if (!alert) main.classList.add('pt-20', 'lg:pt-36');
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/Header.js